<template>
  <div class="dataBox">
    <el-table
      :data="signContractTipData"
      style="width: 100%;margin-bottom:10px;"
      border
      header-cell-class-name="cellCustomer headerCellCustomer ft14"
      cell-class-name="cellCustomer ft12"
    >
      <template slot="empty">
          <img class="data-pic" src="../../../../../assets/images/H5/null.png" alt="" />
          <br/>
          暂无数据
      </template>
      <el-table-column prop="code" label="合同编号"></el-table-column>
      <el-table-column prop="name" label="合同名称"></el-table-column>
      <el-table-column label="发起方">
        <template slot-scope="scope">
          <span>{{scope.row&&scope.row.contractUser&&scope.row.contractUser.name}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="creditAssignee" label="委托方"></el-table-column>
      <el-table-column label="合同状态">
        <template slot-scope="scope">{{getStatus(scope.row.terminationType)}}</template>
      </el-table-column>
      <el-table-column prop="signStatusTime" label="操作时间"></el-table-column>
      <el-table-column label="操作" width="257px">
        <template slot-scope="scope">
          <div class="handlerBoxCenter">
            <div class="cursorPointer" @click="toDetail(scope.row)">
              <!-- <span class="icon"></span> -->
              <span class="iconDscp">详情</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  data() {
    return {
      signContractTipData: []
    };
  },
  mounted() {},
  methods: {
    setData(data) {
      this.signContractTipData = data;
    },
    getStatus(status) {
      let signStatusKey = ["", "撤回", "拒签", "过期"];
      return signStatusKey[status];
    },
    toDetail(row) {
      this.$emit("toDetail", row);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>
